export { deserializeDeckDocument } from './deserializeDeckDocument';
